/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

const PdfViewRender = ({ pdfFile }) => {
	const toolbarPluginInstance = toolbarPlugin();
	const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;

	const transform = (slot) => ({
		...slot,
		// Download: () => <></>,
		// DownloadMenuItem: () => <></>,
		Open: () => <></>,
		OpenMenuItem: () => <></>,
		EnterFullScreen: () => <></>,
		EnterFullScreenMenuItem: () => <></>,
		SwitchTheme: () => <></>,
		SwitchThemeMenuItem: () => <></>
	});

	return (
		<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
			<div
				className="rpv-core__viewer"
				style={{
					border: "1px solid rgba(0, 0, 0, 0.3)",
					display: "flex",
					flexDirection: "column",
					height: "450px",
					width: "1000px"
				}}
			>
				<div
					style={{
						alignItems: "center",
						backgroundColor: "#eeeeee",
						borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
						display: "flex",
						padding: "0.25rem"
					}}
				>
					<Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
				</div>
				<div
					style={{
						flex: 1,
						overflow: "hidden"
					}}
				>
					<Viewer fileUrl={pdfFile} plugins={[toolbarPluginInstance]} />
				</div>
			</div>
		</Worker>
	);
};

export default PdfViewRender;
